import { useState } from "react";

export default function PdfToImages() {
  const [loading, setLoading] = useState(false);
  const [images, setImages] = useState([]);
  const [format, setFormat] = useState("png"); // png | jpg
  const [jpgQuality, setJpgQuality] = useState(0.9);

  const convertPDF = async (file) => {
    if (!file) return;

    setLoading(true);
    setImages([]);

    try {
      // ✅ pdfjs chargé seulement quand on clique
      const pdfjsLib = await import("pdfjs-dist/legacy/build/pdf");

      // ✅ worker servi depuis /public -> /build
      pdfjsLib.GlobalWorkerOptions.workerSrc =
        `${process.env.PUBLIC_URL}/pdf.worker.min.mjs`;

      const buffer = await file.arrayBuffer();
      const pdf = await pdfjsLib.getDocument({ data: buffer }).promise;

      const results = [];

      for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
        const page = await pdf.getPage(pageNum);

        const scale = 2;
        const viewport = page.getViewport({ scale });

        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        canvas.width = viewport.width;
        canvas.height = viewport.height;

        await page.render({ canvasContext: ctx, viewport }).promise;

        const mime = format === "jpg" ? "image/jpeg" : "image/png";
        const blob = await new Promise((resolve) =>
          canvas.toBlob(
            (b) => resolve(b),
            mime,
            format === "jpg" ? jpgQuality : undefined
          )
        );

        const url = URL.createObjectURL(blob);
        const ext = format === "jpg" ? "jpg" : "png";

        results.push({ page: pageNum, url, name: `page-${pageNum}.${ext}` });
      }

      setImages(results);
    } catch (err) {
      console.error(err);
      alert("Erreur PDF → Images. Regarde la console.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section>
      <h2 className="title-button">Convertisseur PDF en Images</h2>
      <small>PNG ou JPG (tout se fait dans ton navigateur)</small>

      <div style={{ maxWidth: 420, margin: "12px auto", textAlign: "left" }}>
        <label style={{ display: "block", marginBottom: 10 }}>
          Format de sortie
          <select
            value={format}
            onChange={(e) => setFormat(e.target.value)}
            disabled={loading}
            style={{
              width: "100%",
              padding: 10,
              marginTop: 6,
              borderRadius: 5,
              border: "1px solid #ccc",
            }}
          >
            <option value="png">PNG</option>
            <option value="jpg">JPG</option>
          </select>
        </label>

        {format === "jpg" && (
          <label style={{ display: "block", marginBottom: 10 }}>
            Qualité JPG : {Math.round(jpgQuality * 100)}%
            <input
              type="range"
              min="0.5"
              max="1"
              step="0.05"
              value={jpgQuality}
              onChange={(e) => setJpgQuality(Number(e.target.value))}
              disabled={loading}
              style={{ width: "100%" }}
            />
          </label>
        )}
      </div>

      <input
        type="file"
        accept=".pdf"
        onChange={(e) => convertPDF(e.target.files[0])}
        disabled={loading}
      />

      {loading && <p style={{ textAlign: "center" }}>Conversion en cours...</p>}

      <div className="output">
        {images.map((img) => (
          <a key={img.page} href={img.url} download={img.name}>
            Télécharger Page {img.page}
          </a>
        ))}
      </div>
    </section>
  );
}
